// @flow
import React, { useState, useEffect, Fragment } from "react";
import * as R from "ramda";
import "./styles.css";
import { Link } from "react-router-dom";
import Page from "../../components/page";
import TextBox from "../../components/text-box";
import User from "../../models/user";
import { Card } from "../../components/card";
import { search } from "../../libs/utilities";
import queryString from "query-string";
import { MetaData } from "../../components/meta-data";
import TextBlock from "../../components/text-block";
import URL from "../../components/url";
import Email from "../../components/email";
import Checkbox from "../../components/checkbox";
import * as panels from "../../constants/modals";
import SearchBar from "../../components/search-bar";
import { bindActionCreators } from "redux";
import * as userActionCreators from "../../action-creators/user-actions";
import * as modalActionCreators from "../../action-creators/modal-actions";

import { connect } from "react-redux";

type RPropsType = { uid: string, displayName: string, email: string, photoURL: string };

const RowTemplate = ({ uid, displayName, photoURL, email }: RPropsType): React$Element<any> => (
    <Link className={ "user-admin--row" } to={ `/users/${uid}${window.location.search}` }>
        <span className={ "user-admin--avatar" } style={ { backgroundImage: `url("${photoURL}")` } }/>
        <span className={ "user-admin--user-info" }>
            <span className={ "user-admin--user-name" }>{displayName}</span>
            <span className={ "user-admin--email" }>{email}</span>
        </span>
    </Link>
);

type PropsType = {
    admins: ?Object,
    panel: ?Object,
    data: Object,
    datum: ?User,
    match: ?Object,
    teams: ?Object,
    error: ?string
};


const MyScreen = ({ actions, admins, match, panel, data, datum, teams, error }: PropsType) => {
    const [list, setList] = useState([]);
    const [roles, setRoles] = useState({});
    const [currentUser, setCurrentUser] = useState({});
    const [loading, setLoading] = useState(false);
    const [saveError, setSaveError] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isAdmin, setIsAdmin] = useState(Boolean((admins[match.params.id] || {}).isAdmin));
    const handleCurrentUserChange = R.curry((key: string, value: string): void => {
        setCurrentUser({ ...currentUser, [key]: value });
    });
    const getStatus = (uid, team) => {
        const members = team.members || {};
        const member = Object.values(members).find(m => m.uid === uid);
        const isOwner = (_uid: string, _team: Object): boolean => (_team.owner || {}).uid === _uid;
        return (member || {}).status || (isOwner(uid, team) && "Owner") || "Member";
    };
    const setRole = R.curry((role: string, isRole: boolean): void => {
        setRoles({ ...roles, [role]: Boolean(isRole) });
    });
    const saveCurrent = () => {
        setIsSaving(true);
        Promise
            .all([actions.saveUser(currentUser), actions.saveAdmin(currentUser, isAdmin)])
            .finally(() => {
                setIsSaving(false);
            });

    };


    useEffect(() => {

        if (currentUser.uid !== match.params.id) {
            const newUser = R.clone((data || []).find(user => user.uid === match.params.id) || {});
            setCurrentUser(newUser);

        }

    }, [match]);

    const q = queryString.parse(window.location.search);
    const filteredData = search(data, q.search);
    const headerContent = (<button onClick={ () => this[saveCurrent](this.state) }>{"Save"}</button>);
    const teamData = Object.entries(currentUser.teams || {}).map(team => ({ id: team[0], link: `/teams/${team[0]}`, data: team[1] || {}, status: getStatus(currentUser.uid, team[1]) }));
    const teamList = teamData.map(team => (
        <Fragment key={ team.id }>
            <span>
                <Link to={ team.link }>{team.data.name}</Link>
            </span>
            <span>{team.status}</span>
        </Fragment>
    ));
    const avatarData = { src: currentUser.photoURL || "", affirmation: "Close" };
    return (

        <Page RowTemplate={ RowTemplate }
            data={ filteredData }
            headerContent={ headerContent }
            pagination={ false }
            toolbar={ (<SearchBar/>) }
        >
            <section>
                <MetaData
                    created={ currentUser.created }
                    id={ currentUser.uid }
                    updated={ currentUser.updated }
                />
                <Card>
                    <div className={ "user-admin--detail-row" }>
                        <span className={ "user-admin--detail-row-flex-item" }>
                            <URL labelText={ "Avatar" }
                                onChange={ handleCurrentUserChange("photoURL") }
                                value={ currentUser.photoURL || "" }
                            />
                        </span>
                        <span className={ "user-admin--detail-row-flex-item" }>
                            <button
                                className="user-admin--avatar"
                                onClick={ () => {
                                    actions.toggleModal({ modalId: panels.IMAGE_MODAL, payload: avatarData, isOpen: true });
                                } }
                            >
                                <img alt="avatar"
                                    className="user-admin--avatar-image"
                                    src={ currentUser.photoURL || "" }/>
                            </button>
                        </span>
                    </div>
                    <TextBox labelText={ "Name" }
                        onChange={ handleCurrentUserChange("displayName") }
                        value={ currentUser.displayName }/>
                    <Email labelText={ "Email" }
                        readOnly={ true }
                        value={ currentUser.email || "" }/>
                    <TextBlock labelText={ "Bio" }
                        onChange={ handleCurrentUserChange("bio") }
                        value={ currentUser.bio || "" }/>
                </Card>
                <Card>
                    <h3>{"Roles"}</h3>
                    <Checkbox checked={ isAdmin }
                        labelText={ "Admin" }
                        onChange={ () => setRole("isAdmin")(!isAdmin) }/>
                </Card>
                <Card>
                    <h3>{"Teams"}</h3>
                    <div className={ "user-admin--teams" }>
                        {teamList}
                    </div>
                </Card>
            </section>
        </Page>

    );
};

const mapStateToProps = (state: Object): Object => {
    const admins = (state.admins || {}).data || {};
    const teams = (state.teams || {}).data || {};
    const data = Object.values((state.users || {}).data || {});
    return { admins, teams, data, currentPage: 1 };
};

const mapDispatchToProps = (dispatch): Object => ({
    actions: bindActionCreators({ ...userActionCreators, ...modalActionCreators }, dispatch)
});

export const UsersScreen = connect(mapStateToProps, mapDispatchToProps)(MyScreen);